import clsx from 'clsx';
import { HashtagIcon, TagIcon } from '@heroicons/react/24/outline';
import { ThemeTag } from '@/features/analyze/components/Tag';
import { useTranslation } from 'react-i18next';

export type TopicTooltipProps = {
  name: string;
  description?: string | null;
  themes?: readonly string[] | null;
  isSocialIssue?: boolean;
  className?: string;
  id?: string;
};

export const TopicTooltip = ({
  name,
  description,
  themes,
  isSocialIssue,
  className,
  id,
}: TopicTooltipProps) => {
  const { t } = useTranslation();
  const themeList = Array.isArray(themes) ? themes.filter(Boolean) : [];

  return (
    <div
      id={id}
      role="tooltip"
      className={clsx(
        'pointer-events-auto z-50 rounded-xl border border-gray-200 bg-white px-4 py-3 text-left text-sm text-gray-900 shadow-lg',
        className
      )}
    >
      <div className="flex flex-col gap-2">
        {isSocialIssue ? (
          <div className="mb-1 flex items-center gap-2">
            <span className="text-xs font-semibold text-red-500">
              <TagIcon className="mr-1 inline-block size-4" />
              {t('Issue Tags')}
            </span>
          </div>
        ) : null}
        <div className="mb-1 text-lg font-bold leading-tight">{name}</div>
        {description && (
          <div className="mb-2 text-xs text-gray-600">{description}</div>
        )}
        {themeList.length > 0 && (
          <div className="flex flex-col gap-1">
            <span className="text-xs text-gray-600">{t('関連テーマ')}</span>
            <div className="flex flex-wrap gap-1">
              {themeList.map((theme) => (
                <ThemeTag key={theme} icon={HashtagIcon} tableName={theme} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
